import { render, staticRenderFns } from "./LeaveTab.vue?vue&type=template&id=facfc656&scoped=true"
import script from "./LeaveTab.vue?vue&type=script&lang=js"
export * from "./LeaveTab.vue?vue&type=script&lang=js"
import style0 from "./LeaveTab.vue?vue&type=style&index=0&id=facfc656&prod&lang=scss&scoped=true"
import style1 from "./LeaveTab.vue?vue&type=style&index=1&id=facfc656&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facfc656",
  null
  
)

export default component.exports